export const GETALLCREDITCARDSDATA = "GETALLCREDITCARDSDATA";
export const GETALLCOMPANYNAMES = "GETALLCOMPANYNAMES";
export const LOAD_COMPANYNAMES_REQUEST = "LOAD_COMPANYNAMES_REQUEST";
export const LOAD_COMPANYNAMES_SUCCESS = "LOAD_COMPANYNAMES_SUCCESS";
export const LOAD_COMPANYNAMES_FAILURE = "LOAD_COMPANYNAMES_FAILURE";
export const LOAD_ORGANIZATIONS_SUCCESS = "LOAD_ORGANIZATIONS_SUCCESS";
export const ISRELOAD = "ISRELOAD";
